/*
 * Fixes conflicts arising between prototype and jQuery hide events, see BQEP-8722
 * Github issue:
 * https://github.com/twbs/bootstrap/issues/8379#issuecomment-37451624
 * More about this bootstrap/prototype conflict here:
 * http://softec.lu/site/DevelopersCorner/BootstrapPrototypeConflict
 * TODO: review this at a later date to see if it was fixed in later versions of bootstrap, this code may no longer be necessary
 */
jQuery(window).ready(function()
    {
        if (typeof Prototype !== "undefined" && Prototype.BrowserFeatures.ElementExtensions) {
            var disablePrototypeJS = function (method, pluginsToDisable) {
                    var handler = function (event) {
                        event.target[method] = undefined;
                        setTimeout(function () {
                            delete event.target[method];
                        }, 0);
                    };
                    pluginsToDisable.each(function (plugin) {
                        jQuery(window).on(method + '.bs.' + plugin, handler);
                    });
                },
            //example of elements that can be altered, should problems arise in the future, add some to the uncommented array
            //pluginsToDisable = ['collapse', 'dropdown', 'modal', 'tooltip', 'popover'];
                pluginsToDisable = ['popover'];
            //uncomment if show events start misbehaving
            //disablePrototypeJS('show', pluginsToDisable);
            disablePrototypeJS('hide', pluginsToDisable);
        }
    }
);